module.exports = "//public.getcloudapp.com/packs/media/images/icons-add-637fed7d75f2d07a4627f7b85e09e580.svg";